export default __webpack_public_path__ + "static/media/7070ROUGE.063a3eb7.pdf";